import { render, staticRenderFns } from "./CardRounded.vue?vue&type=template&id=6cf8cdc1"
import script from "./CardRounded.vue?vue&type=script&lang=ts"
export * from "./CardRounded.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports